//src/pages/profile/ProfilePage.jsx
import React, { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { Link, useNavigate } from "react-router-dom";
import { FaAngleRight, FaSignOutAlt, FaTags, FaUserAlt, FaMedal } from "react-icons/fa";
import { BADGES, getBadge } from "../../utils/Badges";
import BadgeModal from "../../components/common/BadgeModal";
import { MdCalendarMonth } from "react-icons/md";
import profile_eval from "../../assets/images/profile_eval.png";
import profile from "../../assets/images/profile.png";
// import soon from "../../assets/images/soon.gif";
import { IoIosMail } from "react-icons/io";
import { BsBagHeartFill } from "react-icons/bs";
import { PiCoinsFill } from "react-icons/pi";
import { fetchBalance, fetchPurchases }from "../../api/credits/creditsApi";
import { getLearnerPastAssestment } from "../../api/learner/learnerApi";
import ViewPastAssessments from "./ViewPastAssessments";
import { FaHome, FaShoppingCart, FaBoxOpen } from "react-icons/fa";


const ProfilePage = () => {
  const { user, logout } = useAuth();
  const [balance, setBalance] = useState(0);
   const [rows, setRows] = useState([]);
  const currentDate = new Date().toLocaleDateString();
  const navigate = useNavigate();
  const user_id = localStorage.getItem("user_id");
  const [badgeInfo, setBadgeInfo] = useState({ badge: null, next: BADGES[0], total : 0 });
  const [showBadgeModal, setShowBadgeModal] = useState(false);
  const [openSidebar, setOpenSidebar] = useState(false);

  useEffect(() => {
  getLearnerPastAssestment(user?.email).then((res) => {
    const total = res.data?.data?.length || 0;
    setBadgeInfo({ ...getBadge(total), total });
    });
  }, [user?.email]);

   useEffect(() => {
      fetchBalance(user_id).then((res) => setBalance(res.data.balance));
      fetchPurchases(user_id).then((res) => setRows(res.data));
    }, [user_id]);
  const handleBuyAssessment = () =>{
    navigate("/buy_items");
  }
  const handleOrderHistory = () =>{
    navigate("/your_order_history");
  }
  const nameColor = badgeInfo.badge ? badgeInfo.badge.color : "#22c55e";
  console.log(nameColor);
  return (
    <>
    <div className="flex bg-gray-100">


<div
  className="
    group
    w-[70px] hover:w-64
    h-screen
    sticky top-0
    bg-white border-r border-indigo-100
    flex flex-col
    overflow-hidden
    transition-all duration-300
  "
>
  <div>
 <div className="p-4 border-b border-indigo-100 flex items-center justify-center group-hover:justify-start gap-3">
  <div className="p-[2px] rounded-lg bg-gradient-to-br from-indigo-500 via-purple-500 to-indigo-600 shadow-md">
    <div className="bg-white rounded-lg p-[2px]">
      <img
        src={profile}
        className="w-10 h-10 rounded-md object-cover"
      />
    </div>

  </div>
  <div className="hidden group-hover:block whitespace-nowrap">
    <p className="text-sm font-semibold text-gray-800">
      {user?.fullName || "User"}
    </p>
    <p className="text-xs text-indigo-500">Profile</p>
  </div>

</div>

    <div className="mt-2 space-y-1 px-2">
      <Link to="/dashboard">
        <div className="flex items-center justify-center group-hover:justify-start gap-3 px-3 py-3 rounded-lg hover:bg-gradient-to-r hover:from-purple-100 hover:to-blue-100 cursor-pointer transition">
         <FaHome className="text-xl text-[#36369f]" />

          <span className="hidden group-hover:block text-sm font-medium text-gray-700">
            Dashboard
          </span>

          <FaAngleRight className="hidden group-hover:block ml-auto text-indigo-400" size={12} />
        </div>
      </Link>

      <div className="flex items-center justify-center group-hover:justify-start gap-3 px-3 py-3 rounded-lg hover:bg-gradient-to-r hover:from-purple-100 hover:to-blue-100 cursor-pointer transition">
       <IoIosMail className="text-xl text-[#36369f]" />
        <span className="hidden group-hover:block text-sm text-gray-700 truncate">
          {user?.email}
        </span>
      </div>

      <div className="flex items-center justify-center group-hover:justify-start gap-3 px-3 py-3 rounded-lg hover:bg-gradient-to-r hover:from-purple-100 hover:to-blue-100 cursor-pointer transition">
        <MdCalendarMonth className="text-xl text-[#36369f]" />
        <span className="hidden group-hover:block text-sm text-gray-700">
          {currentDate}
        </span>
      </div>

     
      <div className="flex items-center justify-center group-hover:justify-start gap-3 px-3 py-3 rounded-lg hover:bg-gradient-to-r hover:from-purple-100 hover:to-blue-100 cursor-pointer transition">
        <PiCoinsFill className="text-xl text-[#36369f]" />
        <span className="hidden group-hover:block text-sm text-gray-700">
          {balance} credits
        </span>
      </div>

      <div
        onClick={() => setShowBadgeModal(true)}
        className="flex items-center justify-center group-hover:justify-start gap-3 px-3 py-3 rounded-lg hover:bg-gradient-to-r hover:from-purple-100 hover:to-blue-100 cursor-pointer transition"
      >
        <FaMedal className="text-xl text-[#36369f]" />
        <span className="hidden group-hover:block text-sm text-gray-700">
          My Badges
        </span>
      </div>

      
      <div
        onClick={handleBuyAssessment}
        className="flex items-center justify-center group-hover:justify-start gap-3 px-3 py-3 rounded-lg hover:bg-gradient-to-r hover:from-purple-100 hover:to-blue-100 cursor-pointer transition"
      >
        <FaShoppingCart className="text-xl text-[#36369f]" />
        <span className="hidden group-hover:block text-sm text-gray-700">
          Buy Assessments
        </span>
      </div>

      
      <div
        onClick={handleOrderHistory}
        className="flex items-center justify-center group-hover:justify-start gap-3 px-3 py-3 rounded-lg hover:bg-gradient-to-r hover:from-purple-100 hover:to-blue-100 cursor-pointer transition"
      >
        <FaBoxOpen className="text-xl text-[#36369f]" />
        <span className="hidden group-hover:block text-sm text-gray-700">
          My Orders
        </span>
      </div>

    </div>
  </div>

  
  <div className="mt-auto border-t border-indigo-100 p-2">
    <button
      onClick={logout}
      className="w-full flex items-center justify-center group-hover:justify-start gap-3 px-3 py-3 rounded-lg text-red-500 hover:bg-red-50 transition"
    >
      <FaSignOutAlt className="text-xl" />
      <span className="hidden group-hover:block text-sm">
        Logout
      </span>
    </button>
  </div>
</div>


  <div className="flex-1 p-6">
    <div className="bg-green-50 border border-green-300 rounded-lg shadow-sm p-4 mb-4 text-sm text-green-800">
  You can get the details of your previously attended assesment & download your answers along with certificate of appreciation.
</div>

    <div className="bg-white rounded-lg shadow-sm border p-4">
      <ViewPastAssessments />
    </div>
  </div>

</div>
    {showBadgeModal && (
      <BadgeModal
        totalAssessments={badgeInfo.total}
        onClose={() => setShowBadgeModal(false)}
      />
    )}
    </>
  );
};

export default ProfilePage;
